import { ActivityDetail, ActivityTask } from "types/summary";
import { GridReadyEvent, RowNode } from "ag-grid-community";
import { useAxios } from "myAxios";
import { broadcastActivityChange, refreshDetailGrid } from "utils";
import { mutate } from "swr";

export const isSameOrgForActivity = (activity?: ActivityDetail) => {
  if (!activity) return false;
  return activity.editable;
};

export const isActivityTaskEditable = (activity?: ActivityDetail) => {
  if (!activity) return false;
  if (activity.systemRelated) {
    return activity.category === "SYSTEM";
  } else {
    return activity.editable;
  }
};

export const isActivityEditable = (activity?: ActivityDetail) => {
  if (!activity) return false;
  if (activity.systemRelated) {
    return false;
  } else {
    return activity.editable;
  }
};

export const isActivityDeletable = (activity?: ActivityDetail) => {
  if (!activity) return false;
  return activity.deletable;
};

export const isTaskEditable = (task?: ActivityTask) => {
  if (!task) return false;
  if (!task.taskId) {
    return false;
  } else if (task.systemRelated) {
    return !task.system;
  } else {
    return task.editable;
  }
};

export const isTaskDeletable = (task?: ActivityTask) => {
  if (!task) return false;
  if (task.systemRelated) {
    return !task.system;
    // Task page when it is a fake task record
  } else if (task.taskId === null) {
    return false;
  } else {
    return task.deletable;
  }
};

export async function mutateTask(taskId?: string, gridEvent?: GridReadyEvent, activityId?: string) {
  const axios = useAxios();
  await new Promise<void>((resolve) => setTimeout(resolve, 500));
  const filters = [];
  if (activityId) {
    filters.push({ field: "id", operator: "eq", value: activityId });
  }
  if (taskId) {
    filters.push({ field: "taskId", operator: "eq", value: taskId });
  }
  const { data: mutateData } = await axios.post<any[]>(`/api/task`, {
    filters,
  });
  console.debug(`Refresh grid for task ${taskId}`);
  if (mutateData) {
    const rowNodes: RowNode[] = [];
    mutateData.forEach((x) => {
      const node = gridEvent?.api?.getRowNode(x.taskId || x.id || "");
      if (node) {
        node.updateData(x);
        rowNodes.push(node);
      }
    });
    if (rowNodes.length) {
      console.debug(`Get grid node for task ${taskId}`);
      gridEvent?.api.redrawRows({ rowNodes });
    }
  }
}

// export const mutateTask = async (
//   activityId?: string,
//   taskId?: string,
//   gridEvent?: GridReadyEvent
// ): Promise<ActivityTask | undefined> => {
//   const axios = useAxios();
//   await new Promise<void>((resolve) => setTimeout(resolve, 500));
//   const { data: oriData } = await axios.post<ActivityTask[]>(`/api/task`, {
//     filters: [{ field: "taskId", operator: "eq", value: taskId }],
//   });
//   console.debug(`Refresh grid for task ${taskId}`);
//   const mutateData = oriData?.[0];
//   if (mutateData) {
//     const node = gridEvent?.api?.getRowNode(taskId || "");
//     if (node) {
//       console.debug(`Get grid node for task ${taskId}`);
//       node.updateData(mutateData);
//       gridEvent?.api.redrawRows({ rowNodes: [node] });
//     }
//     return mutateData;
//   }
// };

export const mutateActivity = async (
  activityId?: string,
  gridEvent?: GridReadyEvent
): Promise<ActivityDetail | undefined> => {
  const axios = useAxios();
  await new Promise<void>((resolve) => setTimeout(resolve, 500));
  const { data: mutateData } = await axios.get<ActivityDetail>(
    `/api/dataservice/v1/activities/${activityId}?includeTasks=1`
  );
  console.debug(`Refresh grid for activity ${activityId}`);
  if (mutateData) {
    const node = gridEvent?.api?.getRowNode(activityId || "");
    if (node) {
      console.debug(`Get grid node for activity ${activityId}`);
      node.updateData(mutateData);
      refreshDetailGrid(mutateData.tasks || [], activityId, gridEvent);
      console.debug(`Refresh detail grid node for activity ${activityId}`);
      gridEvent?.api.redrawRows({ rowNodes: [node] });
    }
    return mutateData;
  }
};

export const mutateActivityDetail = async (
  accountKey?: string,
  activityId?: string,
  deleted = false
) => {
  await mutate(`/api/dataservice/v1/accounts/${accountKey}/activities/${activityId}`);

  broadcastActivityChange(activityId, deleted);

  //fresh the task list
  await mutate(`/api/dataservice/v1/accounts/${accountKey}/activities/${activityId}/tasks`);
  await mutate(`/api/dataservice/v1/event/histories?bomId=${activityId}`);
  await mutate(`/api/dataservice/v1/activities/${activityId}/playcards`);
};

export const validateActivity = (detail: ActivityDetail | undefined | null): boolean => {
  if (
    detail?.type === null ||
    detail?.type === "" ||
    detail?.purpose === null ||
    detail?.purpose === "" ||
    detail?.products === null ||
    (detail?.products && detail?.products?.length === 0)
  ) {
    return false;
  }
  return true;
};
